import React from "react";
import { Box } from "@mui/material";
import { colors, fonts, layout } from "../../theme/tokens";

const ShieldIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2 3 7v6c0 5 3.8 8 9 9 5.2-1 9-4 9-9V7l-9-5Z"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="m9 12 2 2 4-4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
const ClockIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M12 8v4l3 2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
const GlobeIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18M12 3c-2.5 2.5-2.5 15 0 18"
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </svg>
);
const PeopleIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M16 11a4 4 0 1 0-4-4M8 11a4 4 0 1 0 0-8M3 21v-2a4 4 0 0 1 4-4h2M21 21v-2a4 4 0 0 0-4-4h-2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const whyUs = [
  {
    title: "Deep Expertise",
    body: "Decades of hands-on experience across all sectors, including oil and gas, finance, manufacturing, technology, and healthcare.",
    icon: ShieldIcon,
  },
  {
    title: "Personalised Approach",
    body: "Every solution is tailored to your unique goals and challenges, with no cookie-cutter strategies.",
    icon: ClockIcon,
  },
  {
    title: "Global Perspective",
    body: "Based in Nigeria, serving clients across West Africa and internationally through affiliations and partnerships.",
    icon: GlobeIcon,
  },
  {
    title: "Trusted Partnerships",
    body: "We work alongside your team as long-term partners, invested in your sustained success.",
    icon: PeopleIcon,
  },
];

const WhyUs = () => {
  return (
    <Box
      component="section"
      sx={{ py: "64px", px: { xs: "20px", md: "28px" } }}
    >
      <Box sx={{ maxWidth: layout.maxWidth, mx: "auto" }}>
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: "44px" }}>
          <Box
            sx={{ display: "inline-flex", alignItems: "center", gap: "12px" }}
          >
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              WHY ARGYLE
            </Box>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(30px,3.6vw,44px)",
              lineHeight: 1.1,
              letterSpacing: "-.02em",
              color: colors.navyInk,
              mt: "16px",
              mb: 0,
            }}
          >
            What sets us apart
          </Box>
          <Box
            sx={{
              fontFamily: fonts.body,
              fontSize: "16.5px",
              lineHeight: 1.65,
              color: colors.mutedText,
              maxWidth: "600px",
              mx: "auto",
              mt: "16px",
            }}
          >
            We combine deep technical expertise with a genuine commitment to
            your success. Clients choose us because we deliver real results, not
            just reports.
          </Box>
        </Box>

        {/* Cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(4,1fr)",
            },
            gap: "18px",
          }}
        >
          {whyUs.map((w) => (
            <Box
              key={w.title}
              sx={{
                background: "#fff",
                border: `1px solid ${colors.lineSoft}`,
                borderRadius: "22px",
                p: "30px 26px",
                boxShadow: "0 14px 34px -26px rgba(14,27,42,.5)",
                transition: "transform .4s cubic-bezier(.2,.7,.2,1)",
                "&:hover": { transform: "translateY(-6px)" },
              }}
            >
              <Box
                sx={{
                  width: "52px",
                  height: "52px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg,#EAF1F8,#F4F7FB)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: colors.steelBlue,
                }}
              >
                {w.icon}
              </Box>
              <Box
                component="h3"
                sx={{
                  fontFamily: fonts.display,
                  fontWeight: 600,
                  fontSize: "19px",
                  color: colors.navyInk,
                  mt: "20px",
                  mb: 0,
                }}
              >
                {w.title}
              </Box>
              <Box
                sx={{
                  fontFamily: fonts.body,
                  fontSize: "14px",
                  lineHeight: 1.6,
                  color: "#6A7888",
                  mt: "10px",
                }}
              >
                {w.body}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default WhyUs;
